// src/Pages/Cotisation/Cotisation.js
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { useHistory } from "react-router-dom";
import TemplateCotisation from '../../Templates/TemplateCotisation/TemplateCotisation';
import { Text } from '../../Atoms';
import { useCotisationData } from './useCotisationData';

const COLUMN_TITLES = [
  'CODE POLICE',
  'DATE DE RÉGLEMENT',
  'ÉCHÉANCE',
  'MONTANT À PAYER',
  'MONTANT DÛ',
  'MONTANT RÉGLÉ',
  'REMARQUE',
  'FRAIS',
  'STATUT'
];

const Cotisation = ({ user }) => {
  const URL_CONFIRMATION_PRELEVEMENT = '/cotisation/prelevement/confirmation'; 

  const history = useHistory();
  const [formData, setFormData] = useState({});
  const {
    data,
    error,
    methodePaiement,
    codeMethodePaiement,   
    montantApayer,
    montantAcompte
  } = useCotisationData();

    const onClickPrelevement = () => {
    history.push('/cotisation/demande-prelevement');
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Form data submitted:', formData);
  };

  if (error) {
    return (
      <Text
        className="m-4 text-center p-4"
        text="Une erreur est survenue lors de la récupération des données."
        type="h4"
      />
    );
  }

  return (
    <TemplateCotisation
      columnTitles={COLUMN_TITLES}
      visibleRows={false}
      data={data}
      onClickPrelevement={onClickPrelevement}
      handleSubmit={handleSubmit}
      handleInputChange={handleInputChange}
      methodePaiement={methodePaiement}
      montantApayer={montantApayer}
      montantAcompte={montantAcompte}
      codeTiers={user?.codeTiers}
      codeMethodePaiement={codeMethodePaiement}
      urlPrelevement = {URL_CONFIRMATION_PRELEVEMENT}
    />
  );
};

Cotisation.propTypes = {
  user: PropTypes.shape({
    codeTiers: PropTypes.string.isRequired,
  }).isRequired,
};

const mapStateToProps = (state) => ({
  user: state.auth.user
});

export default connect(mapStateToProps)(Cotisation);
